<div class="modal-backdrop fade"
     [class.show]="show"></div>
<div class="modal d-block fade"
     [class.show]="show"
     tabindex="-1"
     role="dialog"
     aria-labelledby="modalIdLabel">
  <div role="document"
       class="modal-dialog modal-dialog-centered"
       style="max-width: 50%">
    <div class="modal-content"
         style="min-height: 60vh">
      <div class="modal-header">
        <h5 class="modal-title text-primary-dark">
          Service Categories
          <a class="mt-3 mx-2 border rounded border-primary text-primary p-2"
             routerLink="new"
             *hasPermission="['services-category.create']"
             style="text-decoration: none; cursor: pointer">
            <ezy-icons src="/assets/icons/plus-primary.svg"
                       class="text-primary"></ezy-icons>
            Add Category
          </a>
        </h5>
        <button type="button"
                class="close"
                (click)="close()"
                aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p-table [value]="serviceCategories$|async"
                 [reorderableColumns]="true"
                 [scrollable]="true"
                 [scrollHeight]="'500px'"
                 [loading]="isLoading"
                 class="table table-borderless borderless">
          <ng-template pTemplate="body"
                       let-rowData
                       let-index="rowIndex">
            <tr [pReorderableRow]="index">
              <td style="width: 2rem">
                <span class="pi pi-bars"
                      pReorderableRowHandle
                      style="padding-top: 15px">
                  <!-- <ezy-icons src="/assets/icons/draggable.svg"></ezy-icons> -->
                </span>
              </td>
              <td>
                <div class="row">
                  <div class="col-2">
                    <img [src]="rowData.icon"
                         style="display: inline-block; margin: 2px 0 2px 2px"
                         width="48" />
                  </div>
                  <div class="col-8 text-bols">
                    {{ rowData.name }}
                    <br />
                    {{ rowData.services }} services
                  </div>
                </div>
              </td>
              <td class="float-right">
                <ezy-icons class="action"
                           [routerLink]="rowData.id"
                           *hasPermission="['services-category.edit']"
                           src="/assets/icons/pen.svg"></ezy-icons>
                <ezy-icons class="action"
                           *hasPermission="['services-category.delete']"
                           (click)="handleDelete(rowData)"
                           src="/assets/icons/trash-alt.svg"></ezy-icons>
                <span style="margin-left: 25px"
                      class="custom-checkbox">
                  <input type="checkbox"
                         id="checkbox-{{ rowData.id }}"
                         [checked]="rowData.published"
                         (click)="handlePublish(rowData, $event)"
                         class="custom-control-input">
                  <label for="checkbox-{{ rowData.id }}"
                         class="custom-control-label">Publish</label>
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>
<router-outlet></router-outlet>
